export const state = {
  fieldsStatus: {
    mediaName: true,
    date: true,
    licensePlate: true,
    driver: true,
    vehicleType: false,
    vehicleGroup: false,
    address: true,
  },
  defaultCameraThumbnail: 1,
  groupingBasedOnDate: true,
  modalStatus: {
    show: false,
    data: {},
  },
  modalMedia: null,
  search: '',
}

export const getters = {}

export const mutations = {
  setFieldsStatus(state, payload) {
    state.fieldsStatus.mediaName = payload.mediaName
    state.fieldsStatus.date = payload.date
    state.fieldsStatus.licensePlate = payload.licensePlate
    state.fieldsStatus.driver = payload.driver
    state.fieldsStatus.vehicleType = payload.vehicleType
    state.fieldsStatus.vehicleGroup = payload.vehicleGroup
    state.fieldsStatus.address = payload.address
  },
  setDefaultCameraThumbnail(state, payload) {
    state.defaultCameraThumbnail = payload
  },
  setGroupingBasedOnDate(state, payload) {
    state.groupingBasedOnDate = payload
  },
  setModalMedia(state, payload) {
    state.modalMedia = payload
  },
  setSearch(state, payload) {
    state.search = payload
  },
}
